export default __webpack_public_path__ + "static/media/header-logo-web.f13cd860.svg";